"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ky_config_1 = require("../config/ky.config");
var service_status_enum_1 = __importDefault(require("../enums/service-status.enum"));
var getDefaultParams_1 = __importDefault(require("../helpers/getDefaultParams"));
var alp_mapper_1 = require("../mappers/alp.mapper");
var AlpService = {
    getAlps: function (studentId, schoolYear, contentType) {
        var params = (0, getDefaultParams_1.default)();
        var schoolYearParam = schoolYear ? "&schoolYear=".concat(schoolYear) : "";
        var contentTypeParam = contentType ? "&contentType=".concat(contentType) : "";
        return (0, ky_config_1.get)("".concat(params.baseUrl, "Alp/Lookup/").concat(studentId).concat(params.defaultParams).concat(schoolYearParam).concat(contentTypeParam, "&includeLessons=true"))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, (0, alp_mapper_1.MapAlps)(response)); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    getAlp: function (ilpID) {
        var params = (0, getDefaultParams_1.default)();
        return (0, ky_config_1.get)("".concat(params.baseUrl, "Alp/").concat(ilpID).concat(params.defaultParams))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    getAlpIncludeAssignedLessons: function (ilpId) {
        var params = (0, getDefaultParams_1.default)();
        return (0, ky_config_1.get)("".concat(params.baseUrl, "Alp/").concat(ilpId, "/IncludeAssignedLessons").concat(params.defaultParams))
            .then(function (response) { return response.json(); })
            .then(function (response) {
            return formatAlpResponse(service_status_enum_1.default.LOADED, (0, alp_mapper_1.MapAlpWithLessons)(response, true));
        })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    getAlpAssessments: function (ilpID) {
        var params = (0, getDefaultParams_1.default)();
        return (0, ky_config_1.get)("".concat(params.baseUrl, "Alp/").concat(ilpID, "/GetAssessments").concat(params.defaultParams))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    getLessonMetadataByPathId: function (pathId, studentId, ilpStandardCode, state, subject, gradeLevel) {
        if (state === void 0) { state = ""; }
        if (subject === void 0) { subject = ""; }
        if (gradeLevel === void 0) { gradeLevel = null; }
        var params = (0, getDefaultParams_1.default)();
        var level = !gradeLevel && gradeLevel !== 0 ? "" : "&gradeLevel=".concat(gradeLevel);
        return (0, ky_config_1.get)("".concat(params.baseUrl, "Lesson/").concat(pathId, "/Metadata").concat(params.defaultParams, "&ilpStandardCode=").concat(ilpStandardCode, "&studentId=").concat(studentId, "&state=").concat(state, "&subject=").concat(subject).concat(level))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    sendViewEvent: function (request) {
        var params = (0, getDefaultParams_1.default)();
        var url = "".concat(params.baseUrl, "Lesson/SendViewEvent");
        return (0, ky_config_1.post)(url, { json: request });
    },
    assessmentCreateTake: function (assignmentId, pathId) {
        var params = (0, getDefaultParams_1.default)();
        var extraParams = new URLSearchParams({
            assignmentId: assignmentId,
            pathId: pathId.toString()
        });
        var url = "".concat(params.baseUrl, "Alp/Assessment/CreateTake?").concat(extraParams.toString());
        return (0, ky_config_1.post)(url)
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    assessmentUpdateTake: function (takeId, status) {
        var params = (0, getDefaultParams_1.default)();
        var extraParams = new URLSearchParams({
            takeId: takeId,
            status: status
        });
        var url = "".concat(params.baseUrl, "Alp/Assessment/").concat(takeId, "?").concat(extraParams.toString());
        return (0, ky_config_1.put)(url)
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    getNextActivity: function (lessonId, lessonVersion, ilpId) {
        var params = (0, getDefaultParams_1.default)();
        var body = {
            lessonId: lessonId,
            ilpId: ilpId,
            version: lessonVersion
        };
        var url = "".concat(params.baseUrl, "Alp/Lesson/Hierarchy/GetNextActivity");
        return (0, ky_config_1.post)(url, { json: body })
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatAlpResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatAlpResponse(service_status_enum_1.default.ERROR, error); });
    },
    updateByTakeId: function (takeId, status, schoolYear, gradeBand) {
        var params = (0, getDefaultParams_1.default)();
        var extraParams = new URLSearchParams();
        // Add parameters only if they have a valid value
        if (status)
            extraParams.append("status", status);
        if (schoolYear)
            extraParams.append("schoolYear", schoolYear.toString());
        if (gradeBand)
            extraParams.append("gradeBand", gradeBand);
        var url = "".concat(params.baseUrl, "Alp/Activity/Hierarchy/UpdateByTakeId/").concat(takeId, "?").concat(extraParams);
        return (0, ky_config_1.post)(url)
            .then(function (response) { return response.json(); })
            .catch(function (error) { return error; });
    }
};
exports.default = AlpService;
var formatAlpResponse = function (status, response) { return ({ status: status, response: response }); };
